import { useQuery } from "@tanstack/react-query";
import { getNationalitiesAction } from "@/actions/nationality.action";
import { type Nationality } from "@/types/nationality";

const extractNationalities = (res: unknown): Nationality[] => {
  if (!res || typeof res !== "object") {
    return [];
  }

  const result = res as {
    success?: boolean;
    data?: unknown;
  };

  if (!result.success) {
    return [];
  }

  if (Array.isArray(result.data)) {
    return result.data as Nationality[];
  }

  if (
    result.data &&
    typeof result.data === "object" &&
    Array.isArray((result.data as { data?: unknown }).data)
  ) {
    return (result.data as { data: Nationality[] }).data;
  }

  return [];
};

export const useNationalities = () => {
  return useQuery({
    queryKey: ["nationalities"],
    queryFn: getNationalitiesAction,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours since it rarely changes
    select: extractNationalities,
  });
};
